// Maps a /v2/api/lead-gen/profiles item onto ContractorCard's props. The
// endpoint has no business-vs-individual distinction (unlike the static
// CONTRACTORS dummy data), so that stays unset.
export function mapContractorProfile(profile) {
  const location =
    [profile.orgDetails?.locality, profile.orgDetails?.city].filter(Boolean).join(", ") || null;

  return {
    profileId: profile.contractorProfileId ?? null,
    href: profile.contractorProfileId
      ? `/digital-profile/${profile.contractorProfileId}?isLeadGenProfile=true`
      : undefined,
    coverImage: profile.latestImages?.[0] ?? null,
    photosCount: profile.totalPhotosCount ?? null,
    contractorName: profile.contractorName,
    contractorImage: profile.contractorPicture ?? null,
    location,
    workExpYears: profile.workExperienceV2 ?? null,
    projectsCount: profile.projectCount ?? null,
    labourCost: profile.avgLabourCost ?? null,
  };
}
